// react library imports
import { motion } from 'framer-motion';
import { useDispatch } from 'react-redux';

// style and local component imports
import './UserHeader.css';
import UserHeaderCard from './UserHeaderCard';

// main component imports and imports from utils
import { headingAnimation } from 'Utils/animation';
import VideoPlayer from '../VideoPlayer/VideoPlayer';

// redux store imports
import { openSchedule, openDownloadPopup } from 'Redux/popup/popup';

const Header = ({data, handleNavigation, name}) => {
  // define dispatch action from redux store
  const dispatch = useDispatch()

  // handle get started 
  const handleGetStarted = () =>{
    if (handleNavigation) {
      handleNavigation()
    }else{
      dispatch(openDownloadPopup(name))
    }
  }
  return (
    <motion.div initial="hidden" animate="show"
    transition={{staggerChildren:0.05}}>
      <header className='user_header_container padding_container'>
        <section className='user_header_info_container mues_column_space_between mues_row_gap_8'>
            <motion.h2 className='mues_font_weight_700 
            mues_black' dangerouslySetInnerHTML={{__html:data.title}}
            variants={headingAnimation}/>
            <motion.h6 className='mues_font_weight_500 mues_grey_I'
            variants={headingAnimation}>{data.description}</motion.h6>
            <motion.div className='mues_row_space_between mues_column_gap_16
            user_header_button_container' variants={headingAnimation}>
                <button className='btn medium_btn 
                blue_btn' data-testid="mues_user_header_01"
                onClick={handleGetStarted}>Get Started</button>
                <button className='btn medium_btn
                blue_btn mues_white' data-testid="mues_user_header_02"
                onClick={()=>dispatch(openSchedule())}>Schedule a call</button>
            </motion.div>
        </section>
        <motion.div className='user_header_video_container mues_row_center'
        variants={headingAnimation}>
          <div className='user_header_video'>
            <VideoPlayer thumbnail={data.thumbnail} src={data.video} 
            className="video_controller_icon"/>
            <div className='user_header_icon mues_red_background_gradient'/>
            <div className='user_header_icon_two mues_yellow_background_gradient'/>
          </div>
        </motion.div>
      </header>
      <div className='padding_container user_card_list_container'>
        {data.list.map(item=>(
          <UserHeaderCard title={item.title}
          description={item.description}
           key={item.id} logo={item.logo}/>
        ))}
      </div>
    </motion.div>
  )
}

export default Header